import Vue from 'vue'
import Router from 'vue-router'
import detail from '@/pages/detail/detailIndex'
import login from '@/pages/login/login'
import canvass from '@/pages/canvass/canvass'
import result from '@/pages/result/result'
import all from '@/pages/all/all'
import success from '@/pages/success/success'
import errorPage from '@/pages/error/error'
import agreement from '@/pages/agreement/agreement'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/canvass',
      name: 'canvass',
      component: canvass
    },
    {
      path: '/result',
      name: 'result',
      component: result
    },
    {
      path: '/all',
      name: 'all',
      component: all
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/errorPage',
      name: 'errorPage',
      component: errorPage
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement
    }
  ],
  // mode: 'history', //后端支持可开
  // base: "/test/",
  scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js